import { providerProducts } from "@/business/constants";

const adaptForProductsTab = (records = []) => {
  const productsList = [];
  for (let record of records) {
    const addedProduct = [];
    for (let subtype in providerProducts.subtypes) {
      if (record[subtype]) {
        addedProduct = record[subtype];
        addedProduct.provider_product_id = record.id;
        addedProduct.entityKey = subtype;
      }
    }
    addedProduct.price = record.price;
    addedProduct.id = record.id;
    productsList.push(addedProduct);
  }
  return productsList;
};

const adaptForContactForm = (apiData = {}, contactType = 'provider') => {
  const results = {
    [contactType]: {},
    requisites: {},
  };
  for (let fieldName in apiData) {
    if (fieldName === "requisite_id") {
      results.requisites = apiData[fieldName];
    } else {
      results[contactType][fieldName] = apiData[fieldName];
    }
  }
  return results;
};

const responseAdapter = {
  adaptForProductsTab,
  adaptForContactForm,
};

export default responseAdapter;



// WEBPACK FOOTER //
// ./src/business/api-services/_responseAdapter.js